import { store } from "../redux/store";
import { updateReduxAction } from "../redux/actions";
import { callGetEndpoint } from "../api-calls/readApiService";
import { isEmptyObject } from "../utilities/helpers";

export async function checkIsProEditMode(projectId: number, unitId: number) {
  const response = await callGetEndpoint("readapi/isProEditMode", projectId, unitId);
  return response;
}
